import httpClient from "./httpClient";

export function getOnlineFeeConfig() {
  return httpClient.get("/online-fee-config").then((res) => res.data.data);
}

export function listAllOnlineFeeConfigs() {
  return httpClient.get("/online-fee-config/all").then((res) => res.data.data);
}

export function saveOnlineFeeConfig(payload) {
  return httpClient.post("/online-fee-config", payload).then((res) => res.data.data);
}
